<template>
  <Retail />
</template>
<script>
import Retail from "@/components/Retail.vue";
export default {
  components: {
    Retail
  }
}
</script>